import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const U = (id) => `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=85`;

export const FALLBACK_SETTINGS = {
  brand: { company_name: "Cyber Planet", tagline: "Changing the world for you!", logo_url: "", favicon_url: "" },
  contact: { phone: "", email: "info@cyberplanet.online", address: "" },
  social: [
    { platform: "facebook", url: "" },
    { platform: "instagram", url: "" },
    { platform: "x", url: "" },
    { platform: "linkedin", url: "" },
    { platform: "youtube", url: "" },
  ],
  menu: [
    { label: "Home", path: "/", enabled: true },
    { label: "Services", path: "/services", enabled: true },
    { label: "Events", path: "/events", enabled: true },
    { label: "Contact", path: "/contact", enabled: true },
  ],
  seo: { ga_id: "", gsc_verification: "", header_script: "", body_script: "", footer_script: "" },
  images: {
    hero: U("1548094990-c16ca90f1f0d"),
    team: U("1522071820081-009f0129c71c"),
    concert: U("1563841930606-67e2bce48b78"),
    stage: U("1459749411175-04bf5292ceea"),
    broadcast: U("1600779547877-be592ef5aad3"),
    office: U("1568992688065-536aad8a12f6"),
    "service-branding": U("1524749292158-7540c2494485"),
    "service-software": U("1542831371-29b0f74f9713"),
    "service-advertising": U("1600779547877-be592ef5aad3"),
    "service-social": U("1522071820081-009f0129c71c"),
    "service-analytics": U("1568992688065-536aad8a12f6"),
    "service-tech": U("1680992046626-418f7e910589"),
    "service-events": U("1563841930606-67e2bce48b78"),
    "service-radiotv": U("1459749411175-04bf5292ceea"),
  },
};

const CACHE_KEY = "cp_settings_cache";

const loadCached = () => {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (raw) return { ...FALLBACK_SETTINGS, ...JSON.parse(raw) };
  } catch (e) {
    return null;
  }
  return null;
};

const SettingsContext = createContext({ settings: FALLBACK_SETTINGS, loading: true, reload: () => {} });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(() => loadCached());

  const reload = () =>
    api
      .get("/settings")
      .then((r) => {
        setSettings(r.data);
        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify(r.data));
        } catch (e) {}
      })
      .catch(() => setSettings((s) => s || FALLBACK_SETTINGS));

  useEffect(() => {
    reload();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings: settings || FALLBACK_SETTINGS, loading: !settings, reload }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
